import { supabase } from '../../lib/supabase/client'
import { TABLES } from '../../lib/supabase/contracts.full'

export type Exercise = {
  id: string
  owner_id: string | null
  name: string
  primary_muscle: string | null
  equipment: string | null
  tracking_type: string | null
  is_system: boolean
  is_active: boolean
  secondary_muscles: string[] | null
  aliases: string[] | null
  description: string | null
  setup_instructions: string | null
  execution_instructions: string | null
  breathing_instructions: string | null
  common_mistakes: string | null
  safety_notes: string | null
  movement_pattern: string | null
  laterality: string | null
  load_mode: string | null
  image_key: string | null
}

export type ExerciseFilters = {
  query?: string
  muscle?: string
  equipment?: string
}

function normalise(value: string) {
  return value.trim().toLocaleLowerCase('de-CH')
}

export async function listExercises(filters: ExerciseFilters = {}): Promise<Exercise[]> {
  const { data, error } = await supabase
    .from(TABLES.exercises)
    .select('id,owner_id,name,primary_muscle,equipment,tracking_type,is_system,is_active,secondary_muscles,aliases,description,setup_instructions,execution_instructions,breathing_instructions,common_mistakes,safety_notes,movement_pattern,laterality,load_mode,image_key')
    .eq('is_active', true)
    .order('name')

  if (error) throw error

  const query = filters.query ? normalise(filters.query) : ''
  const muscle = filters.muscle ? normalise(filters.muscle) : ''
  const equipment = filters.equipment ? normalise(filters.equipment) : ''

  return ((data ?? []) as Exercise[]).filter((exercise) => {
    const searchable = [exercise.name, ...(exercise.aliases ?? [])].map(normalise)
    const queryMatches = !query || searchable.some((value) => value.includes(query))
    const muscleMatches = !muscle || normalise(exercise.primary_muscle ?? '') === muscle || (exercise.secondary_muscles ?? []).some((value) => normalise(value) === muscle)
    const equipmentMatches = !equipment || normalise(exercise.equipment ?? '') === equipment
    return queryMatches && muscleMatches && equipmentMatches
  })
}

export async function getExercise(id: string): Promise<Exercise> {
  const { data, error } = await supabase
    .from(TABLES.exercises)
    .select('id,owner_id,name,primary_muscle,equipment,tracking_type,is_system,is_active,secondary_muscles,aliases,description,setup_instructions,execution_instructions,breathing_instructions,common_mistakes,safety_notes,movement_pattern,laterality,load_mode,image_key')
    .eq('id', id)
    .single()

  if (error) throw error
  return data as Exercise
}
